import { axiosInstance } from './AxiosConfig';

export const registerUserActivity = (functionId, comment) => {
    axiosInstance.post('/shop/stats', {
        function_id: functionId,
        function_text: comment
    })
        .then(response => {
        })
        .catch(error => {
            console.error('Error registering activity:', error);
        });
};

export const registerActivityInAnalytics = (title, category, value=1) => {
    if (typeof window.gtag === 'function') {
        window.gtag('event', title, {
            event_category: category,
            event_label: title,
            value: value,
            debug_mode: true
        });
    } else {
        console.warn('Google Analytics is not initialized');
    }
}

